import KTBSProgressBar from "general/components/OtherKeenComponents/KTBSProgressBar";
import AppColors from "general/constants/AppColors";
import Utils from "general/utils/Utils";
import PropTypes from "prop-types";

BuildInfoCardView.propTypes = {
    type: PropTypes.string,
    commissionType: PropTypes.string,
    bgIconColor: PropTypes.string,
    icon: PropTypes.element,
    name: PropTypes.string,
    defaultText: PropTypes.string,
    defaultValue: PropTypes.any,
    textHeader: PropTypes.arrayOf(PropTypes.string),
    contents: PropTypes.array,
    additionalClassName: PropTypes.string,
    additionalButton: PropTypes.element,
};

function BuildInfoCardView({
    type = "text",
    commissionType,
    bgIconColor,
    icon,
    name,
    defaultText,
    defaultValue,
    textHeader,
    contents,
    additionalClassName = "",
    additionalButton = null,
}) {
    return (
        <div
            className={`rounded-lg p-4 ${additionalClassName}`}
            style={{
                border: `1px solid ${AppColors.gray[300]}`,
                boxShadow: "0px 7px 8px -3px #0000000D",
                backgroundColor: "#fff",
                borderBottom: `4px solid ${bgIconColor}`,
            }}
        >
            <div className="d-flex gap-2 align-items-center">
                <div
                    className="d-flex flex-column align-items-center justify-content-center w-32px h-32px rounded-lg"
                    style={{ backgroundColor: bgIconColor, fontSize: 8 }}
                >
                    {icon}
                </div>
                <div
                    className="font-weight-bolder"
                    style={{ color: AppColors.gray[800], fontSize: 15 }}
                >
                    {name}
                </div>
            </div>
            <div
                className="my-4 w-100"
                style={{ borderBottom: `1px dashed ${AppColors.gray[300]}` }}
            />
            {type === "progress" && Array.isArray(contents) && (
                <>
                    {contents.map((content, index) => (
                        <div key={index}>
                            <div
                                className="font-weight-bold mt-2"
                                style={{ color: AppColors.gray[700], fontSize: 13 }}
                            >
                                {content?.description}
                            </div>
                            <div
                                style={{
                                    color: AppColors.gray[800],
                                    fontSize: Utils.returnFontSize(13),
                                    fontWeight: 600,
                                }}
                            >
                                <KTBSProgressBar
                                    completed={content?.completed}
                                    value={content?.value}
                                    maxValue={content?.maxValue}
                                    bgColor={content?.bgColor}
                                />
                            </div>
                        </div>
                    ))}
                    {additionalButton && (
                        <div
                            className="font-weight-bold mt-4"
                            style={{ color: AppColors.gray[700], fontSize: 13 }}
                        >
                            {additionalButton}
                        </div>
                    )}
                </>
            )}
            {type === "table" && (
                <div>
                    {defaultValue && (
                        <div
                            className="font-weight-boldest"
                            style={{ color: AppColors.gray[800], fontSize: 14 }}
                        >
                            {defaultValue}
                        </div>
                    )}
                    {defaultText && (
                        <div
                            className="font-weight-bold mb-2"
                            style={{ color: AppColors.gray[700], fontSize: 13 }}
                        >
                            {defaultText}
                        </div>
                    )}
                    <div className="rounded-lg" style={{ border: "1px solid #EBEDEF" }}>
                        <table className="w-100" style={{ borderCollapse: "collapse" }}>
                            <thead>
                                <tr
                                    className="font-weight-bolder p-3"
                                    style={{
                                        backgroundColor: "#F7F7FD",
                                        fontSize: Utils.returnFontSize(12),
                                        color: AppColors.gray[800],
                                    }}
                                >
                                    {textHeader?.map((header, index) => (
                                        <th
                                            key={index}
                                            className={`p-3 ${index === 0 ? "text-left" : "text-right"}`}
                                        >
                                            {header}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(contents) &&
                                    contents.map((content, index) => (
                                        <tr
                                            key={index}
                                            style={{ borderTop: "1px solid #EBEDEF" }}
                                        >
                                            {commissionType === "landlord" ? (
                                                <>
                                                    <td className="p-3 text-left">{content?.name}</td>
                                                    <td className="p-3 text-right">
                                                        {Utils.formatNumber(content?.value)} VNĐ
                                                    </td>
                                                </>
                                            ) : (commissionType === "package" || commissionType === "sale" || commissionType === "chargepoint") ? (
                                                <>
                                                    <td className="p-3 text-left">
                                                        {Utils.formatNumber(content?.revenue)} VNĐ
                                                    </td>
                                                    <td className="p-3 text-right">
                                                        {Math.round(content?.discount * 100)}%
                                                    </td>
                                                </>
                                            ) : (
                                                <>
                                                    <td className="p-3 text-left"
                                                        dangerouslySetInnerHTML={{
                                                            __html: Array.isArray(content?.name)
                                                                ? content?.name.join("<br />")
                                                                : content?.name,
                                                        }}
                                                    />
                                                    <td className="p-3 text-right"
                                                        dangerouslySetInnerHTML={{
                                                            __html: Array.isArray(content?.value)
                                                                ? content?.value.join("<br />")
                                                                : content?.value,
                                                        }}
                                                    >
                                                    </td>
                                                </>
                                            )}
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>

                    {additionalButton && (
                        <div
                            className="font-weight-bold mt-4"
                            style={{ color: AppColors.gray[700], fontSize: 13 }}
                        >
                            {additionalButton}
                        </div>
                    )}
                </div>
            )}
            {type === "text" && Array.isArray(contents) && (
                <>
                    {contents.map((content, index) => !content?.hide && (
                        <div key={index}>
                            <div
                                className={`font-weight-boldest ${index > 0 ? "mt-4" : ""} w-100`}
                                style={{ color: AppColors.gray[800], fontSize: 14 }}
                                dangerouslySetInnerHTML={{
                                    __html: Array.isArray(content.value)
                                        ? content?.value.join("<br />")
                                        : content?.value,
                                }}
                            />
                            <div className="d-flex gap-2 align-items-center">
                                <div
                                    className="font-weight-bold mt-2"
                                    style={{ color: AppColors.gray[700], fontSize: 13 }}
                                    dangerouslySetInnerHTML={{
                                        __html: Array.isArray(content.description)
                                            ? content?.description.join("<br />")
                                            : content?.description,
                                    }}
                                />
                                {content?.additionalTooltip && (
                                    <div
                                        className="font-weight-bold mt-4"
                                        style={{ color: AppColors.gray[700], fontSize: 13 }}
                                    >
                                        {content?.additionalTooltip}
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </>
            )}
        </div>
    );
};

export default BuildInfoCardView;